import axios from 'axios';
const axiosServices = axios.create();

axios.interceptors.request.use(config => {
  config.headers['X-Tenant-ID'] = localStorage.getItem('tenantId');
  return config;
});

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosServices;
